import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import LeagueSeasonDivisionApi from './LeagueSeasonDivisionApi';

let settings;

export default settings = {
    key: 'league/divisions',
    zone: 'leagues',
    path: '/league/divisions',
    title: "League Divisions",
    endpoint: LeagueSeasonDivisionApi.endpoint,
    modelName: 'LeagueSeasonDivision',
    idKey: 'id',
    primaryKey: 'name',
    actions: ['trash'],
    indexCaps: ["viewLeagueSeasonDivision"],
    viewCaps: ["viewLeagueSeasonDivision"],
    createCaps: ["createLeagueSeasonDivision"],
    updateCaps: ["updateLeagueSeasonDivision"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Table",
                path: settings.path + "/type/table",
            },
            {
                label: "Bracket",
                path: settings.path + "/type/bracket",
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: LeagueSeasonDivisionApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['host', 'season'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.type) filters.where.type = { inq: [params.type] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['name'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Name",
                key: "name",
                type: "text",
            },
            {
                label: "Host",
                key: "hostId",
                type: "relationship",
                model: "Hosts",
            },
            {
                label: "Season",
                key: "seasonId",
                type: "relationship",
                model: "LeagueSeason",
            },
            {
                label: "Type",
                key: "type",
                type: "choice",
                options: [
                    { value: "table", label: "Table" },
                    { value: "bracket", label: "Bracket" }
                ],
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Name",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Host",
                key: "host",
                format: "ModelLink",
            },
            {
                label: "Season",
                key: "season",
                format: "ModelLink",
            },
            {
                label: "Type",
                key: "type",
                format: "titleCase",
            },
            {
                label: "No. of Teams",
                key: "noOfTeams",
                format: "number",
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: LeagueSeasonDivisionApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: LeagueSeasonDivisionApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['host', 'season'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        if (data && data.season && data.season.title) title = title + ", " + data.season.title;

        return title;

    },
    singleButtons: (routeName, params, users, fetch) => {

        const data = get(fetch, 'data');

        if (data) {

            return [
                {
                    label: "Manage Season",
                    path: "/league/seasons/" + data.seasonId + "/view",
                }
            ]

        }

        return [];

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit",
                caps: settings.updateCaps
            },
            {
                label: "Schedule Games",
                path: path + "/schedule",
                caps: settings.updateCaps
            },
        ]

    },
};